// Prebuilt pipeline stages — not editable by users. Custom stages (stored in
// the backend) use keys of the form `custom_<id>`.
export const PREBUILT_STAGES = [
  { key: 'lead', label: 'Lead', icon: '🎯', locked: true }, // always the first stage
  { key: 'contacted', label: 'Contacted', icon: '📞' },
  { key: 'qualified', label: 'Qualified', icon: '✅' },
  { key: 'discovery_call', label: 'Discovery Call', icon: '📅' },
  { key: 'proposal_sent', label: 'Proposal Sent', icon: '📄' },
  { key: 'negotiation', label: 'Negotiation', icon: '🤝' },
  { key: 'won', label: 'Won', icon: '🏆' },
  { key: 'lost', label: 'Lost', icon: '❌' },
  { key: 'retainer', label: 'Retainer', icon: '⭐' },
  { key: 're_nurture', label: 'Re-nurture', icon: '♻️' },
];

// Icon library for custom stages.
export const STAGE_ICONS = [
  '🎯', '📞', '✅', '📅', '📄', '🤝', '🏆', '❌', '⭐', '♻️',
  '💬', '📧', '📋', '💰', '💡', '🔍', '🚀', '🔔', '📊', '🧲',
  '🗓️', '✍️', '📈', '🎬', '🧪', '🛠️', '🤖', '🌱', '🔥', '🏁',
];
